import React, { Component } from 'react';
import Autocomplete from '../common/autocomplete';
import strings from '../locales/';

const Header = props => (
  <div className="header between">
    <div className="header_box_filter">

    </div>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./source/client/components/account_extended_property/header.jsx